import { wireIntake } from './y3dm-intake-client.js';
import { MATERIAL_CATALOG } from './y3dm-material-catalog.js';
import { renderProperties } from './y3dm-material-properties.js';
function initialize(scope) {
  const roots = [...scope.querySelectorAll('[data-y3dm-wholesale]')];
  if (scope.matches?.('[data-y3dm-wholesale]')) roots.unshift(scope);
  roots.forEach(root => {
    if (root.dataset.initialized) return; root.dataset.initialized = 'true';
    const config = JSON.parse(document.getElementById(root.dataset.configId).textContent);
    const select = root.querySelector('[data-wholesale-material]');
    const color = root.querySelector('[data-wholesale-color]');
    const materials = (config.materials?.length ? config.materials : MATERIAL_CATALOG).map(item => {
      const base = MATERIAL_CATALOG.find(m => m.id === item.id) || {};
      const names = String(item.colorNames || '').split(',').map(x => x.trim()).filter(Boolean);
      return {...base,...item, colors: names.length ? names : item.colors?.length ? item.colors.map(c => typeof c === 'string' ? c : c.name) : (base.colors || []).map(c => c.name)};
    });
    select.replaceChildren(new Option('Choose a material', ''));
    materials.forEach(m => select.add(new Option(m.label, m.id))); select.disabled = !materials.length;
    function change() {
      const material = materials.find(m => m.id === select.value);
      color.replaceChildren(new Option(material ? 'Choose a color' : 'Choose a material first', ''));
      (material?.colors || []).forEach(name => color.add(new Option(name, name))); color.disabled = !material;
      const info = root.querySelector('[data-wholesale-info]'); info.hidden = !material;
      root.querySelector('[data-wholesale-description]').textContent = material?.description || '';
      renderProperties(root.querySelector('[data-material-properties]'), material?.id, '');
    }
    select.addEventListener('change', change);
    root.querySelector('form').addEventListener('reset-complete', change);
    change(); wireIntake(root, config, 'wholesale');
  });
}
initialize(document);
document.addEventListener('shopify:section:load', e => initialize(e.target));
